import React from 'react'
import { Section } from '../components/section'
import { Permission, UserRole } from 'settings/schema'
import { PermissionToggle } from '../components/permissionToggle'

interface OrderPermissionsSectionProps {
    userRole: UserRole
    isAdminGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
}

export const OrderPermissionsSection = ({
    userRole,
    isAdminGranted,
    handlePermissionClick,
}: OrderPermissionsSectionProps) => (
    <Section title="Order permissions" className="order-permissions">
        <div className="row">
            <PermissionToggle
                permission="access_orders"
                handleClick={handlePermissionClick}
                disabled={isAdminGranted || userRole === 'reseller'}
            />
            <PermissionToggle permission="edit_orders" handleClick={handlePermissionClick} disabled={isAdminGranted} />
            {userRole !== 'reseller' && (
                <PermissionToggle
                    permission="create_order"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted}
                />
            )}
        </div>
        <div className="row">
            <PermissionToggle
                permission="export_orders"
                handleClick={handlePermissionClick}
                disabled={isAdminGranted}
            />
        </div>
        {userRole !== 'reseller' && (
            <div className="row">
                <PermissionToggle
                    permission="refund_orders"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted}
                />
            </div>
        )}
    </Section>
)
